// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"130":"be4f11cc","239":"7791b193","453":"fe88814f","455":"62c22a92","638":"52936f96","977":"3a0a2507"}[chunkId] + ".chunk.js";
};